import axios from 'axios';
import { getClerkSessionToken } from '@/services/clerk';

const apiUrl = process.env.VUE_APP_NODE_ENV === 'production'
  ? process.env.VUE_APP_PROD_API_URL
  : process.env.VUE_APP_DEV_API_URL;

const notificationsApi = axios.create({
  baseURL: `${apiUrl.replace(/\/$/, '')}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

export async function confirmQuote(recordId) {
  const response = await notificationsApi.post(
    `/public/quotes/${encodeURIComponent(recordId)}/confirm`,
  );

  return response.data;
}

export async function updateOpportunityStatus(recordId, status, currency) {
  const sessionToken = await getClerkSessionToken();

  if (!sessionToken) {
    throw new Error('You must be signed in to update an opportunity.');
  }

  const response = await notificationsApi.patch(
    `/opportunities/${encodeURIComponent(recordId)}/status`,
    { status, currency },
    {
      headers: {
        Authorization: `Bearer ${sessionToken}`,
      },
    },
  );

  return response.data;
}
